var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "column-template-container" }, [
    _c("div", { staticClass: "column-text" }, [
      _vm._v(_vm._s(_vm.data.headerText)),
    ]),
    _c("div", {
      staticClass: "border",
      style: _vm.renderBorderColor(_vm.data.keyField),
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }